import { Fragment, useCallback, useContext, useRef, useState } from "react";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import MaintenancesList from "./MaintenancesList";
import MaintenanceImportModal from "../components/MaintenanceImportModal";
import { HiOutlineTrash } from "react-icons/hi2";

const MaintenancesListWrapper = () => {

    // STATES

    const [openFormDrawer, setOpenFormDrawer] = useState<boolean>(false);
    const [maintenanceSelected, setMaintenanceSelected] = useState<any | null>(null);
    const [isOpenImportModal, setIsOpenImportModal] = useState(false);
    const [openDeleteAllModal, setOpenDeleteAllModal] = useState(false);
    const maintenancesTableRefetchRef = useRef<(() => void) | null>(null);
    const defaultFilters = {};

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de mantenimientos' },
        { name: 'Mantenimientos', href: menuRoutes.maintenances.path }
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    const registerTableRefetch = useCallback((fn: () => void) => {
        maintenancesTableRefetchRef.current = fn;
    }, []);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Listado de mantenimientos" breadcrumb={breadCrumb}>
                    <div className="flex gap-3 mt-4 md:mt-0">
                        {
                            userCan('delete_all', 'maintenance') &&
                            (
                                <Button color="danger" onClick={() => setOpenDeleteAllModal(true)} className={cn(['mt-4 md:mt-0'])}>
                                    <HiOutlineTrash className="w-4 h-4" />
                                    <span className="ms-2">Eliminar todos los mantenimientos</span>
                                </Button>
                            )
                        }
                        {
                            userCan('create', 'provider') &&
                            (
                                <Button
                                    variant="outline"
                                    onClick={() => setIsOpenImportModal(true)}
                                >
                                    Importar Excel
                                </Button>
                            )
                        }
                        {
                            userCan('create', 'maintenance') &&
                            (
                                <Button
                                    color="primary"
                                    onClick={() => { 
                                        setOpenFormDrawer(true);
                                        setMaintenanceSelected(null);
                                    }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Crear mantenimiento
                                </Button>
                            )
                        }
                    </div>
                </PageHeader>
                <MaintenancesList 
                    openFormDrawer={openFormDrawer} 
                    setOpenFormDrawer={setOpenFormDrawer} 
                    maintenanceSelected={maintenanceSelected} 
                    setMaintenanceSelected={setMaintenanceSelected} 
                    openDeleteAllModal={openDeleteAllModal}
                    setOpenDeleteAllModal={setOpenDeleteAllModal}
                    registerTableRefetch={registerTableRefetch}
                />
                <MaintenanceImportModal 
                    isOpen={isOpenImportModal} 
                    onClose={() => setIsOpenImportModal(false)} 
                    refetch={() => {
                        maintenancesTableRefetchRef.current?.();
                    }} 
                />
            </FiltersProvider>
        </Fragment>
    );
};

export default MaintenancesListWrapper;